// App.jsx
import React, { useLayoutEffect } from "react";

import './App.css';

import { BrowserRouter, Routes, Route, useLocation, useNavigate, useNavigationType } from "react-router-dom";

import { AuthProvider } from "./context/authContext";
import PrivateRoute from "./components/PrivateRoute";
import ConnectionOverlay from "./components/ConnectionOverlay";
import UpdateBanner from "./components/UpdateBanner";
import UsoTracker from "./components/UsoTracker";
import UsoApp from "./pages/superadmin/UsoApp";
import { removeOnlyKeys } from "./utils/session";

import Login from "./Login";

import AdminPanel from "./pages/Admin";

import AdminGestionUsuarios from "./pages/admin/AdminGestionUsuarios";
import HistorialUsuarios from "./pages/admin/HistorialUsuarios";
import FormularioUsuario from './pages/admin/FormularioUsuario';
import AdminSupervisorasEncargadas from './pages/admin/AdminSupervisorasEncargadas';
import AdminGestionEncargados from './pages/admin/AdminGestionEncargados';
import SeguimientoRutaSupervisora from './pages/admin/SeguimientoRutaSupervisora';
import AnalisisAsitentas from './pages/supervisora/AnalisisAsitentas';
import AnalisisSupervisoras from './pages/admin/AnalisisSupervisoras';
import AnalisisPisos from './pages/supervisora/AnalisisPisos';
import AnalisisAlumnos from './pages/supervisora/AnalisisAlumnos';
import ReporteDiarioCoordinadora from './pages/supervisora/ReporteDiarioCoordinadora';
import ReportesDiariosResponsable from './pages/admin/ReportesDiariosResponsable';
import VerReporteAsistentas from './pages/supervisora/VerReporteAsistentas';
import VerReporteSupervisoras from './pages/supervisora/VerReporteSupervisoras';

import AdminGestionProductos from "./pages/admin/compras/AdminGestionProductos";
import FormularioProductos from "./pages/admin/compras/FormularioProductos";

import AdminGestionPisos from "./pages/admin/compras/AdminGestionPisos";
import CalendarioLimpiezas from "./pages/admin/compras/CalendarioLimpiezas";
import Ruta from "./pages/supervisora/Ruta";
import OrganizarRuta3 from "./pages/supervisora/OrganizarRuta3";
import HistorialPisos from "./pages/admin/compras/HistorialPisos";
import FormularioPiso from "./pages/admin/compras/FormularioPiso";

import AdminGestionAlumnos from "./pages/admin/servicios/AdminGestionAlumnos";
import HistorialAlumnos from "./pages/admin/servicios/HistorialAlumnos";
import FormularioAlumno from "./pages/admin/servicios/FormularioAlumno";
import AdminSeguimientoServicios from "./pages/admin/servicios/AdminSeguimientoServicios";
import AdminOrganizarServicioPiso from "./pages/admin/servicios/AdminOrganizarServicioPiso";
import AdminConfiguracionServicios from "./pages/admin/servicios/AdminConfiguracionServicios";
import AdminReporteOpciones from "./pages/admin/servicios/AdminReporteOpciones";
import AdminIncidenciasOpciones from "./pages/admin/servicios/AdminIncidenciasOpciones";
import AdminOpcionesExtras from "./pages/admin/servicios/AdminOpcionesExtras";
import AdminOpcionesNoHecho from "./pages/admin/servicios/AdminOpcionesNoHecho";
import AdminOpcionesSupervisoraMedia from "./pages/admin/servicios/AdminOpcionesSupervisoraMedia";

import PanelDescargas from "./pages/admin/compras/PanelDescargas"

import VerCompras from "./pages/admin/compras/VerCompras"
import SeguimientoRepartidores from "./pages/admin/compras/SeguimientoRepartidores";
import SeguimientoCompradores from "./pages/admin/compras/SeguimientoCompradores";


import SupervisoraPanel from "./pages/Supervisora";
import FichajePiso from "./components/FichajePiso";
import SupervisoraCompras from "./pages/supervisora/SupervisoraCompras";
import SupervisoraServicios from "./pages/supervisora/SupervisoraServicios";
import Cumpleanos from "./pages/supervisora/Cumpleanos";
import VerDatosCompras from "./pages/supervisora/VerDatosCompras";
import PisoOrganizarServicios from "./pages/supervisora/PisoOrganizarServicios";
import ReporteDiario from "./pages/supervisora/ReporteDiario";
import VerReporteDiario from "./pages/supervisora/VerReporteDiario";
import OrganizarServicioPiso from "./pages/supervisora/OrganizarServicioPiso";

import PisoCrearCompras from "./pages/supervisora/PisoCrearCompras"
import CrearCompras from "./pages/supervisora/CrearCompras"
import Carrito from "./pages/supervisora/Carrito"

import ModificarVerCompras from "./pages/supervisora/ModificarVerCompras"

import SeguimientoDelDia from "./pages/supervisora/SeguimientoDelDia";
import Reportes from "./pages/supervisora/Reportes";
import ReportesDiario from "./pages/supervisora/ReportesDiario";
import ReportesResidentes from "./pages/supervisora/ReportesResidentes";
import ReportesSustituciones from "./pages/supervisora/ReportesSustituciones";
import AdminResidentesPlan from "./pages/admin/servicios/AdminResidentesPlan";
import Prestamos from "./pages/supervisora/Prestamos";

import Contabilidad from "./pages/Contabilidad";

import CompradorPanel from "./pages/Comprador";
import DetalleCompra from "./pages/comprador/DetalleCompra";
import OrdenarCompra from "./pages/comprador/OrdenarCompra";
import VerComprasComprador from "./pages/comprador/VerComprasComprador";

import RepartidorPanel from "./pages/Repartidor";
import Asistenta from "./pages/Asistenta";
import EjecucionPiso from "./pages/asistenta/EjecucionPiso";
import Unauthorized from "./pages/Unauthorized";

import { Navigate } from "react-router-dom";

import GastosReadOnly from "./pages/admin/compras/GastosReadOnly";
import AdminAnalisisDatos from "./pages/admin/compras/AdminAnalisisDatos";

import SuperAdmin from "./pages/superadmin/SuperAdmin";
import SuperAdminCompras from "./pages/superadmin/Compras";
import SuperAdminServicios from "./pages/superadmin/Servicios";
import SuperAdminImportar from "./pages/superadmin/ImportarDatos";
import SuperAdminHistorial from "./pages/superadmin/Historial";
import SuperAdminSustituciones from "./pages/superadmin/Sustituciones";
import SuperAdminNotificaciones from "./pages/superadmin/Notificaciones";
import SuperAdminFichajes from "./pages/superadmin/Fichajes";
import { registrarEntradaHistorial, reanudarFlujoCompra, salidaPorAtras } from "./utils/flujoCompra";

// Roles con acceso a alguna parte del panel admin.
const ROLES_ADMIN_TODOS    = ["admin_compras", "admin_servicios", "admin_asistentas", "superadmin"];
const ROLES_ADMIN_COMPRAS  = ["admin_compras", "superadmin"];
const ROLES_ADMIN_SERVICIOS = ["admin_servicios", "admin_asistentas", "superadmin"];
const ROLES_ADMIN_ASISTENTAS = ["admin_servicios", "admin_asistentas", "superadmin"];
const ROLES_ADMIN_ATCLIENTE  = ["admin_servicios", "admin_atcliente",  "superadmin"];
const ROLES_PISOS = ["admin_compras", "admin_servicios", "admin_asistentas", "superadmin"];
const ROLES_SUPERADMIN     = ["superadmin"];

// Componente persistente (nunca se desmonta) que gestiona el trap del botón
// atrás en /supervisora.
//
// Idea clave:
//  - Cuando el usuario llega a /supervisora con PUSH/REPLACE (login o navegación
//    intencional), se inserta una entrada "dummy" con state={isExitGuard:true}
//    inmediatamente después en el historial.
//  - Cuando el usuario navega a un hijo (/supervisora/compras, etc.) y luego
//    pulsa atrás, popstate aterriza en la dummy (pathname=/supervisora,
//    state.isExitGuard=true): el listener lo detecta y NO muestra confirm.
//  - Cuando el usuario pulsa atrás otra vez desde la dummy, popstate aterriza
//    en la entrada REAL de /supervisora (state sin isExitGuard): ahora SÍ
//    muestra el confirm de cierre de sesión.
// Apunta qué pantalla hay en cada posición del historial (para que al terminar
// una compra "atrás" funcione como un árbol: ver utils/flujoCompra.js).
function RastreoHistorial() {
  const location = useLocation();
  const navType = useNavigationType();
  const navigate = useNavigate();
  // si un "Volver" tras confirmar una compra ha recargado la página, terminarlo aquí
  useLayoutEffect(() => { reanudarFlujoCompra(navigate); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useLayoutEffect(() => {
    // "atrás" tras terminar una compra: no se vuelve a sus pantallas, se sube al panel
    if (salidaPorAtras(navigate, location.pathname, navType)) return;
    registrarEntradaHistorial(window.history.state && window.history.state.idx, location.pathname, navType);
  }, [location.key, location.pathname, navType]);
  return null;
}

function SupervisoraTrap() {
  const location = useLocation();
  const navType = useNavigationType();
  const navigate = useNavigate();

  // Listener permanente — se registra una sola vez
  useLayoutEffect(() => {
    const handlePopState = (e) => {
      // Si aterrizamos en la entrada dummy, el usuario solo está volviendo
      // desde un hijo: silencioso.
      if (e.state && e.state.isExitGuard) return;

      // Si NO es dummy y estamos en /supervisora, el usuario ha pulsado atrás
      // estando ya en /supervisora → mostrar confirm de cerrar sesión.
      if (window.location.pathname !== "/supervisora") return;

      const confirmed = window.confirm("🔒👋 ¿Cerrar sesión y volver al login?");
      if (confirmed) {
        removeOnlyKeys(["user", "session_token", "access_token", "refresh_token"]);
        navigate("/login", { replace: true });
      } else {
        // Reponer dummy para seguir atrapando futuras pulsaciones.
        try {
          window.history.pushState({ isExitGuard: true }, "", window.location.href);
        } catch (_) {}
      }
    };
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, [navigate]);

  // Push del dummy SOLO al llegar a /supervisora vía PUSH/REPLACE (no POP).
  // Si llegamos por POP (volviendo desde un hijo), no añadimos otro dummy.
  useLayoutEffect(() => {
    if (location.pathname !== "/supervisora") return;
    if (navType === "POP") return;
    try {
      window.history.pushState({ isExitGuard: true }, "", window.location.href);
    } catch (_) {}
  }, [location.pathname, location.key, navType]);

  return null;
}

function App() {
  return (
    <AuthProvider>
      <ConnectionOverlay />
      <BrowserRouter>
        {/* dentro del router: no sale en mitad de una compra (mira la ruta) */}
        <UpdateBanner />
        <UsoTracker />
        <RastreoHistorial />
        <SupervisoraTrap />
        <FichajePiso />
        <Routes>
          <Route path="/login" element={<Login />} />
          
          <Route
            path="/admin"
            element={
              // admin_atcliente entra aquí también (el propio AdminPanel ya sabe mostrarle
              // solo lo suyo: "Mis Supervisoras" y reportes de sus encargadas), pero NO se
              // añade a ROLES_ADMIN_TODOS porque esa misma constante también protege
              // /admin/usuarios y /usuarios/nuevo|editar (gestión de usuarios), que no le
              // corresponden a este rol.
              <PrivateRoute allowedRoles={[...ROLES_ADMIN_TODOS, "admin_atcliente"]}>
                <AdminPanel />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/encargadas/:adminUser"
            element={
              <PrivateRoute allowedRoles={[...ROLES_SUPERADMIN, 'admin_asistentas', 'admin_atcliente', 'admin_servicios']}>
                <AdminSupervisorasEncargadas />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/encargados-supervisoras"
            element={
              <PrivateRoute allowedRoles={ROLES_SUPERADMIN}>
                <AdminGestionEncargados />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/seguimiento-ruta-supervisora"
            element={
              <PrivateRoute allowedRoles={[...ROLES_SUPERADMIN, 'admin_asistentas', 'admin_atcliente', 'admin_servicios']}>
                <SeguimientoRutaSupervisora />
              </PrivateRoute>
            }
          />

          <Route
            path="/supervisora/analisis-asistentas"
            element={
              <PrivateRoute allowedRoles={[...ROLES_ADMIN_SERVICIOS, 'admin_atcliente', 'supervisora']}>
                <AnalisisAsitentas />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/analisis-asistentas"
            element={
              <PrivateRoute allowedRoles={[...ROLES_ADMIN_SERVICIOS, 'admin_atcliente']}>
                <AnalisisAsitentas />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/analisis-supervisoras"
            element={
              <PrivateRoute allowedRoles={[...ROLES_ADMIN_SERVICIOS, 'admin_atcliente']}>
                <AnalisisSupervisoras />
              </PrivateRoute>
            }
          />

          <Route
            path="/supervisora/reporte-asistentas"
            element={
              <PrivateRoute allowedRoles={[...ROLES_ADMIN_SERVICIOS, 'admin_atcliente', 'supervisora']}>
                <VerReporteAsistentas />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/reporte-asistentas"
            element={
              <PrivateRoute allowedRoles={["superadmin", "admin_asistentas", "admin_atcliente", "admin_servicios"]}>
                <VerReporteAsistentas />
              </PrivateRoute>
            }
          />

          <Route
            path="/supervisora/reporte-supervisoras"
            element={
              <PrivateRoute allowedRoles={['superadmin', 'admin_asistentas', 'admin_atcliente', 'supervisora']}>
                <VerReporteSupervisoras />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/reporte-supervisoras"
            element={
              <PrivateRoute allowedRoles={['superadmin', 'admin_asistentas', 'admin_atcliente']}>
                <VerReporteSupervisoras />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/analisis-pisos"
            element={
              <PrivateRoute allowedRoles={[...ROLES_ADMIN_SERVICIOS, 'admin_atcliente', 'supervisora']}>
                <AnalisisPisos />
              </PrivateRoute>
            }
          />

          <Route
            path="/supervisora/analisis-pisos"
            element={
              <PrivateRoute allowedRoles={[...ROLES_ADMIN_SERVICIOS, 'admin_atcliente', 'supervisora']}>
                <AnalisisPisos />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/analisis-alumnos"
            element={
              <PrivateRoute allowedRoles={[...ROLES_ADMIN_SERVICIOS, 'admin_atcliente', 'supervisora']}>
                <AnalisisAlumnos />
              </PrivateRoute>
            }
          />

          <Route
            path="/supervisora/analisis-alumnos"
            element={
              <PrivateRoute allowedRoles={[...ROLES_ADMIN_SERVICIOS, 'admin_atcliente', 'supervisora']}>
                <AnalisisAlumnos />
              </PrivateRoute>
            }
          />

          <Route
            path="/supervisora/reporte-diario"
            element={
              <PrivateRoute allowedRoles={['supervisora']}>
                <ReporteDiarioCoordinadora />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/reportes-diarios"
            element={
              <PrivateRoute allowedRoles={[...ROLES_ADMIN_SERVICIOS, 'admin_atcliente']}>
                <ReportesDiariosResponsable />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/usuarios"
            element={
              <PrivateRoute allowedRoles={ROLES_ADMIN_TODOS}>
                <AdminGestionUsuarios />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/usuarios/historial"
            element={
              <PrivateRoute allowedRoles={ROLES_ADMIN_TODOS}>
                <HistorialUsuarios />
              </PrivateRoute>
            }
          />

          <Route
            path="/usuarios/nuevo"
            element={
              <PrivateRoute allowedRoles={ROLES_ADMIN_TODOS}>
                <FormularioUsuario />
              </PrivateRoute>
            }
          />
          <Route 
            path="/usuarios/editar/:user"
            element={
              <PrivateRoute allowedRoles={ROLES_ADMIN_TODOS}>
                <FormularioUsuario />
              </PrivateRoute>
            }
          />
          

          <Route
            path="/admin/productos"
            element={
              <PrivateRoute allowedRoles={ROLES_ADMIN_COMPRAS}>
                <AdminGestionProductos />
              </PrivateRoute>
            }
          />
          <Route 
            path="/productos/nuevo"
            element={
              <PrivateRoute allowedRoles={ROLES_ADMIN_COMPRAS}>
                <FormularioProductos modo="nuevo"/>
              </PrivateRoute>
            }
          />
          <Route 
            path="/productos/editar/:id"
            element={
              <PrivateRoute allowedRoles={ROLES_ADMIN_COMPRAS}>
                <FormularioProductos modo="editar"/>
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/pisos"
            element={
              <PrivateRoute allowedRoles={ROLES_PISOS}>
                <AdminGestionPisos />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/pisos/historial"
            element={
              <PrivateRoute allowedRoles={ROLES_PISOS}>
                <HistorialPisos />
              </PrivateRoute>
            }
          />
          <Route 
            path="/pisos/nuevo"
            element={
              <PrivateRoute allowedRoles={ROLES_PISOS}>
                <FormularioPiso modo="nuevo"/>
              </PrivateRoute>
            }
          />
          <Route 
            path="/pisos/editar/:id"
            element={
              <PrivateRoute allowedRoles={ROLES_PISOS}>
                <FormularioPiso modo="editar"/>
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/alumnos"
            element={
              <PrivateRoute allowedRoles={ROLES_ADMIN_SERVICIOS}>
                <AdminGestionAlumnos />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/alumnos/historial"
            element={
              <PrivateRoute allowedRoles={ROLES_ADMIN_SERVICIOS}>
                <HistorialAlumnos />
              </PrivateRoute>
            }
          />
          <Route
            path="/alumnos/nuevo"
            element={
              <PrivateRoute allowedRoles={ROLES_ADMIN_SERVICIOS}>
                <FormularioAlumno modo="nuevo"/>
              </PrivateRoute>
            }
          />
          <Route
            path="/alumnos/editar/:id"
            element={
              <PrivateRoute allowedRoles={ROLES_ADMIN_SERVICIOS}>
                <FormularioAlumno modo="editar"/>
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/seguimientoServicios"
            element={
              <PrivateRoute allowedRoles={ROLES_ADMIN_SERVICIOS}>
                <AdminSeguimientoServicios />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/organizarServicio"
            element={
              <PrivateRoute allowedRoles={ROLES_ADMIN_SERVICIOS}>
                <AdminOrganizarServicioPiso />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/configuracion-servicios"
            element={
              <PrivateRoute allowedRoles={ROLES_ADMIN_SERVICIOS}>
                <AdminConfiguracionServicios />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/configuracion-servicios/reporte-opciones"
            element={
              <PrivateRoute allowedRoles={ROLES_ADMIN_SERVICIOS}>
                <AdminReporteOpciones />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/configuracion-servicios/incidencias-opciones"
            element={
              <PrivateRoute allowedRoles={ROLES_ADMIN_SERVICIOS}>
                <AdminIncidenciasOpciones />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/configuracion-servicios/opciones-extras"
            element={
              <PrivateRoute allowedRoles={ROLES_ADMIN_SERVICIOS}>
                <AdminOpcionesExtras />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/configuracion-servicios/opciones-no-hecho"
            element={
              <PrivateRoute allowedRoles={ROLES_ADMIN_SERVICIOS}>
                <AdminOpcionesNoHecho />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/configuracion-servicios/supervisoras-media"
            element={
              <PrivateRoute allowedRoles={ROLES_ADMIN_SERVICIOS}>
                <AdminOpcionesSupervisoraMedia />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/descargas"
            element={
              <PrivateRoute allowedRoles={ROLES_ADMIN_COMPRAS}>
                <PanelDescargas />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/calendario-limpiezas"
            element={
              <PrivateRoute allowedRoles={["admin_compras", "superadmin"]}>
                <CalendarioLimpiezas />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/verCompras"
            element={
              <PrivateRoute allowedRoles={ROLES_ADMIN_COMPRAS}>
                <VerCompras />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/seguimiento-repartidores"
            element={
              <PrivateRoute allowedRoles={ROLES_ADMIN_COMPRAS}>
                <SeguimientoRepartidores />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/seguimiento-compradores"
            element={
              <PrivateRoute allowedRoles={ROLES_ADMIN_COMPRAS}>
                <SeguimientoCompradores />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/analisis-datos"
            element={
              <PrivateRoute allowedRoles={ROLES_ADMIN_COMPRAS}>
                <AdminAnalisisDatos />
              </PrivateRoute>
            }
          />

          <Route
            path="/admin/gastos"
            element={
              <PrivateRoute allowedRoles={ROLES_SUPERADMIN}>
                <GastosReadOnly />
              </PrivateRoute>
            }
          />

          <Route
            path="/superadmin"
            element={
              <PrivateRoute allowedRoles={ROLES_SUPERADMIN}>
                <SuperAdmin />
              </PrivateRoute>
            }
          />
          <Route
            path="/superadmin/uso-app"
            element={
              <PrivateRoute allowedRoles={ROLES_SUPERADMIN}>
                <UsoApp />
              </PrivateRoute>
            }
          />
          <Route
            path="/superadmin/compras"
            element={
              <PrivateRoute allowedRoles={ROLES_SUPERADMIN}>
                <SuperAdminCompras />
              </PrivateRoute>
            }
          />
          <Route
            path="/superadmin/servicios"
            element={
              <PrivateRoute allowedRoles={ROLES_SUPERADMIN}>
                <SuperAdminServicios />
              </PrivateRoute>
            }
          />
          <Route
            path="/superadmin/importar"
            element={
              <PrivateRoute allowedRoles={ROLES_SUPERADMIN}>
                <SuperAdminImportar />
              </PrivateRoute>
            }
          />
          <Route
            path="/superadmin/historial"
            element={
              <PrivateRoute allowedRoles={ROLES_SUPERADMIN}>
                <SuperAdminHistorial />
              </PrivateRoute>
            }
          />
          <Route
            path="/superadmin/sustituciones"
            element={
              <PrivateRoute allowedRoles={ROLES_SUPERADMIN}>
                <SuperAdminSustituciones />
              </PrivateRoute>
            }
          />
          <Route
            path="/superadmin/fichajes"
            element={
              <PrivateRoute allowedRoles={ROLES_SUPERADMIN}>
                <SuperAdminFichajes />
              </PrivateRoute>
            }
          />
          <Route
            path="/superadmin/notificaciones"
            element={
              <PrivateRoute allowedRoles={ROLES_SUPERADMIN}>
                <SuperAdminNotificaciones />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/sustituciones"
            element={
              <PrivateRoute allowedRoles={["superadmin", "admin_asistentas"]}>
                <SuperAdminSustituciones />
              </PrivateRoute>
            }
          />

          <Route
            path="/supervisora"
            element={
              <PrivateRoute allowedRoles={["supervisora"]}>
                <SupervisoraPanel />
              </PrivateRoute>
            }
          />
          <Route
            path="/supervisora/compras"
            element={
              <PrivateRoute allowedRoles={["supervisora"]}>
                <SupervisoraCompras />
              </PrivateRoute>
            }
          />
          <Route
            path="/supervisora/verDatosCompras"
            element={
              <PrivateRoute allowedRoles={["supervisora"]}>
                <VerDatosCompras />
              </PrivateRoute>
            }
          />
          <Route path="/supervisora/verReporteDiario" element={<PrivateRoute allowedRoles={["supervisora"]}><VerReporteDiario /></PrivateRoute>} />
          <Route path="/supervisora/reportes" element={<PrivateRoute allowedRoles={["supervisora"]}><Reportes /></PrivateRoute>} />
          <Route path="/supervisora/reportes/diario" element={<PrivateRoute allowedRoles={["supervisora"]}><ReportesDiario /></PrivateRoute>} />
          <Route path="/supervisora/reportes/residentes" element={<PrivateRoute allowedRoles={["supervisora"]}><ReportesResidentes /></PrivateRoute>} />
          <Route path="/supervisora/reportes/sustituciones" element={<PrivateRoute allowedRoles={["supervisora"]}><ReportesSustituciones /></PrivateRoute>} />
          <Route path="/admin/residentes-plan" element={<PrivateRoute allowedRoles={[...ROLES_ADMIN_SERVICIOS]}><AdminResidentesPlan /></PrivateRoute>} />
          <Route
            path="/supervisora/servicios"
            element={
              <PrivateRoute allowedRoles={["supervisora"]}>
                <SupervisoraServicios />
              </PrivateRoute>
            }
          />
          <Route
            path="/supervisora/pisoOrganizarServicios"
            element={
              <PrivateRoute allowedRoles={["supervisora"]}>
                <PisoOrganizarServicios />
              </PrivateRoute>
            }
          />
          <Route
            path="/supervisora/cumpleanos"
            element={
              <PrivateRoute allowedRoles={["supervisora"]}>
                <Cumpleanos />
              </PrivateRoute>
            }
          />
          <Route
            path="/supervisora/reporteDiario"
            element={
              <PrivateRoute allowedRoles={["supervisora"]}>
                <ReporteDiario />
              </PrivateRoute>
            }
          />
          <Route
            path="/supervisora/organizarServicio"
            element={
              <PrivateRoute allowedRoles={["supervisora"]}>
                <OrganizarServicioPiso />
              </PrivateRoute>
            }
          />
          <Route
            path="/supervisora/pisoCrearCompras"
            element={
              <PrivateRoute allowedRoles={["supervisora"]}>
                <PisoCrearCompras />
              </PrivateRoute>
            }
          />
          <Route
            path="/supervisora/crearCompras/:id_piso"
            element={
              <PrivateRoute allowedRoles={["supervisora", "comprador"]}>
                <CrearCompras />
              </PrivateRoute>
            }
          />

          <Route
            path="/supervisora/carrito/:id_piso"
            element={
              <PrivateRoute allowedRoles={["supervisora"]}>
                <Carrito />
              </PrivateRoute>
            }
          />
          <Route
            path="/supervisora/modificarVerCompras"
            element={
              <PrivateRoute allowedRoles={["supervisora"]}>
                <ModificarVerCompras />
              </PrivateRoute>
            }
          />
          <Route
            path="/supervisora/organizar-ruta-3"
            element={
              <PrivateRoute allowedRoles={["supervisora"]}>
                <OrganizarRuta3 />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/organizar-ruta-3"
            element={
              <PrivateRoute allowedRoles={["superadmin", "admin_asistentas", "admin_atcliente"]}>
                <OrganizarRuta3 />
              </PrivateRoute>
            }
          />
          <Route
            path="/supervisora/ruta"
            element={
              <PrivateRoute allowedRoles={["supervisora"]}>
                <Ruta />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/ruta-supervisora"
            element={
              <PrivateRoute allowedRoles={["superadmin", "admin_asistentas", "admin_atcliente"]}>
                <Ruta />
              </PrivateRoute>
            }
          />
          <Route
            path="/supervisora/calendario-limpiezas"
            element={
              <PrivateRoute allowedRoles={["supervisora"]}>
                <CalendarioLimpiezas />
              </PrivateRoute>
            }
          />
          <Route
            path="/supervisora/SeguimientoDelDia"
            element={
              <PrivateRoute allowedRoles={["supervisora"]}>
                <SeguimientoDelDia />
              </PrivateRoute>
            }
          />
          <Route
            path="/supervisora/prestamos"
            element={
              <PrivateRoute allowedRoles={["supervisora"]}>
                <Prestamos />
              </PrivateRoute>
            }
          />
          <Route
            path="/contabilidad"
            element={
              <PrivateRoute allowedRoles={["contabilidad", "superadmin"]}>
                <Contabilidad />
              </PrivateRoute>
            }
          />
  
          <Route
            path="/comprador"
            element={
              <PrivateRoute allowedRoles={["comprador"]}>
                <CompradorPanel />
              </PrivateRoute>
            }
          />
          <Route
            path="/comprador/detalleCompra"
            element={
              <PrivateRoute allowedRoles={["comprador"]}>
                <DetalleCompra />
              </PrivateRoute>
            }
          />
          <Route
            path="/comprador/verCompras"
            element={
              <PrivateRoute allowedRoles={["comprador"]}>
                <VerComprasComprador />
              </PrivateRoute>
            }
          />
          <Route
            path="/comprador/ordenarCompra"
            element={
              <PrivateRoute allowedRoles={["comprador"]}>
                <OrdenarCompra />
              </PrivateRoute>
            }
          />

          <Route
            path="/repartidor"
            element={
              <PrivateRoute allowedRoles={["repartidor"]}>
                <RepartidorPanel />
              </PrivateRoute>
            }
          />

          <Route
            path="/asistenta"
            element={
              <PrivateRoute allowedRoles={["asistenta"]}>
                <Asistenta />
              </PrivateRoute>
            }
          />

          <Route
            path="/asistenta/piso"
            element={
              <PrivateRoute allowedRoles={["asistenta"]}>
                <EjecucionPiso />
              </PrivateRoute>
            }
          />

          <Route
            path="/asistenta/reporteDiario"
            element={
              <PrivateRoute allowedRoles={["asistenta"]}>
                <ReporteDiario />
              </PrivateRoute>
            }
          />

          <Route
            path="/asistenta/verReporteDiario"
            element={
              <PrivateRoute allowedRoles={["asistenta"]}>
                <VerReporteDiario />
              </PrivateRoute>
            }
          />

          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
